export default class resultsHelper {
    constructor(app) {
        this.app = app;
        this.oldValue = null

        /** @type NodeJS.Timeout */
        this.processDelayTimeout = null;
    }

    /**
     * Processa els canvis realitzats
     */
    async process(element, event) {
        if (element && element.quantity && element.quantity < 0) {
            // Quantitats negatives
            element.quantity = -element.quantity
        }

        // Primer cancelar una possible actualització en diferit
        this.clearProcessDelayTimeout();

        // Fer el process
        await this.app.asyncProcess(false);
    }

    /**
     * Processa els canvis, pero amb delay
     */
    async processDelay(e, key_remove_loading) {
        var self = this;
        this.processDelayTimeout = setTimeout(async function () {
            await self.app.asyncProcess(false);
        },
            this.app.isMobile() ? 2500 : 1000
        );
    }
    clearProcessDelayTimeout() {
        if (this.processDelayTimeout) {
            clearTimeout(this.processDelayTimeout)
        }
    }

    // TODO: Refactor

    // quantityChanged(e, key_remove_loading) {
    //     // TODO: Refactor -------------------------------------------
    //     var self = this;

    //     //com a minim el valor ha de ser 0
    //     self.element.quantity = self.element.quantity || 0;

    //     //si usuari escriu nums haventhi ja un 0 treu el 0 de davant
    //     if (self.element.quantity.toString().startsWith("0")) {
    //         self.element.quantity = parseFloat(
    //             self.element.quantity.toString().slice(1)
    //         );
    //     }

    //     //sempre en cualsevol cambi actualitza linea
    //     self.element.subtotal = self.element.quantity * self.element.price;

    //     if (self.lastchangedInputId != e.target.id) {
    //         await self.processDelay(e, key_remove_loading);
    //         self.lastchangedInputId = e.target.id;

    //     } else if (self.lastchangedInputId == e.target.id) {
    //         clearTimeout(self.timeout);
    //         await self.processDelay(e, key_remove_loading);
    //         self.lastchangedInputId = e.target.id;
    //     }
    // }

    onKeyDown(element, event) {
        if (event) {
            // Bloquejar tecles
            if (event.keyCode === 109 || event.keyCode === 189)      // guionet "-"
                event.preventDefault()
            if (event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 110)      // coma i punt ", ."
                event.preventDefault()

        }

    }
    onKeyUp(element, event) {
        this.clearProcessDelayTimeout();
        this.processDelay()
    }
    /**
     * Si l'element té un zero, posar en blanc per facilitar l'edició
     * @param {*} element
     */
    ifCeroBlank(element) {
        element.quantity =
            element.quantity == 0
                ? (element.quantity = "")
                : element.quantity;
    }

    /**
     * Si el textbox està en blanc, posar un 0
     *
     * @param {*} element
     */
    ifBlankCero(element) {
        element.quantity = element.quantity || 0;
    }
}